import ChatMessages from './ChatMessage';

export default ChatMessages;
